import { Box, Toolbar, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

const Styled = {
    Toolbar: styled(Toolbar)(({ theme }) => ({
        minHeight: '68px !important',
        padding: theme.spacing(1.25, 2),
        color: theme.palette.text.primary,
        borderBottom: 'none',
        justifyContent: 'space-between',
        backgroundColor: 'transparent',
        backdropFilter: 'none',
        WebkitBackdropFilter: 'none',
    })),
    Icon: styled(Box)(({ theme }) => ({
        width: 38,
        height: 38,
        flexShrink: 0,
        backgroundColor: alpha(theme.palette.primary.main, 0.085),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 11,
        color: theme.palette.primary.main,
        border: `1px solid ${alpha(theme.palette.primary.main, 0.09)}`,
        '& i, & svg': {
            fontSize: 17,
        },
    })),
    Label: styled(Typography)(({ theme }) => ({
        flex: 1,
        fontSize: '16px',
        fontFamily: 'YekanBalkhHeavy',
        fontWeight: 600,
        textWrap: 'wrap',
        marginInline: theme.spacing(1.5),
        color: theme.palette.text.primary,
    })),
};

export { Styled };
